import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import useSWR from "swr"
import type { BankTransferInvoice, BankTransferInvoiceListItem, Pagination } from "../types"

export const BANK_TRANSFER_INVOICES_ENDPOINT = `${SMOOTH_SMOOTHER_API_URL}/screen/bank_transfer_invoices`

interface ListResponse {
  bankTransferInvoices: BankTransferInvoiceListItem[]
  pagination: Pagination
}

interface ShowResponse {
  bankTransferInvoice: BankTransferInvoice
}

export const useBankTransferInvoices = (page: number) => {
  const { getWithToken } = useSmoothApi()
  const { data, error, isLoading } = useSWR(
    `${BANK_TRANSFER_INVOICES_ENDPOINT}?page=${page}`,
    async (url: string) => (await getWithToken(url)).data as ListResponse,
    { revalidateOnFocus: false }
  )

  return {
    bankTransferInvoices: data?.bankTransferInvoices ?? [],
    pagination: data?.pagination ?? null,
    error: error ?? null,
    isLoading,
  }
}

export const useBankTransferInvoice = (id: number | null) => {
  const { getWithToken } = useSmoothApi()
  const { data, error, isLoading, mutate } = useSWR(
    id ? `${BANK_TRANSFER_INVOICES_ENDPOINT}/${id}` : null,
    async (url: string) => (await getWithToken(url)).data as ShowResponse,
    { revalidateOnFocus: false }
  )

  return {
    bankTransferInvoice: data?.bankTransferInvoice ?? null,
    error: error ?? null,
    isLoading,
    mutate,
  }
}
